import { useRootStore } from 'stores/RootStore'

export const useBlankFrameHints = () => {
  const { designStore, drawersStore } = useRootStore()

  if (!designStore) {
    return false
  }

  const { editor } = designStore

  if (editor.getInstanceState().isReadonly) {
    return false
  }

  const processingShape = designStore.processingShapeId && editor.getShape(designStore.processingShapeId)
  const currentTab = designStore.tab

  return (
    !processingShape &&
    currentTab &&
    !['templates', 'text', 'elements', 'uploads', 'backgrounds'].includes(currentTab) &&
    !drawersStore.drawers.some(
      (drawer) =>
        drawer.component.displayName &&
        ['BackgroundsDrawer', 'ElementsDrawer', 'TextDrawer', 'TemplatesDrawer'].includes(drawer.component.displayName),
    ) &&
    !(editor.getOnlySelectedShape()?.type === 'frame')
  )
}
